<template>
  <generic-modal
    size="large"
    :title="$t('receipt')"
    icon="receipt"
    image="/images/icons/document.png"
    v-on:destroy="destroy"
    :footer_buttons="footer_buttons"
    :show_ok="false"
    :show_cancel="true"
    :scrolling="true"
    ref="modal"
  >
    <div class="description">
      <receipt id="inscription_receipt_print" ref="receipt" />
    </div>
  </generic-modal>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import filters from "@/filters";
// import _ from "lodash";
import GenericModal from "@/components/GenericModal";
import Receipt from "./ReceiptModalReceipt";
import PHE from "print-html-element";

export default {
  name: "ReceiptModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
    Receipt,
  },
  props: { inscription_uuid: String },
  data() {
    return {
      footer_buttons: [
        {
          text: this.$t("print"),
          color: "orange",
          icon: "print",
          click: this.print,
        },
      ],
      info: undefined,
    };
  },
  computed: {},
  methods: {
    destroy() {
      this.$emit("destroy");
      if (this.payment_ok) this.$emit("payment_success", {});
      this.$destroy();
    },
    print() {
      // let vm = this;
      let trgt = document.getElementById("inscription_receipt_print");
      // let opts = {
      //   pageTitle: vm.$t("inscription receipt"),
      //   styles: vm.info.template.template.css,
      // };
      PHE.printElement(trgt);
    },
  },
  created() {
    // let vm = this;
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: { name: ["empty"] },
    });

    local_api(vm, "post", "/student_inscription/do-get-receipt-info", {
      u: vm.inscription_uuid,
    })
      .then((r) => {
        if (r) {
          vm.info = r;
          vm.$refs.receipt.setConfig(r);
        }
      })
      .catch((err) => {
        error_toast(err);
      });

    // local_api(this, "post", "/student_inscription/do-get-configuration")
    //   .then((r) => {
    //     if (r) {
    //       let setup = r.setup ? JSON.parse(r.setup) : {};
    //       if (setup && setup.receipt_layouts) {
    //         let trgt =
    //           setup.receipt_layouts.find((l) => l.set_as_default) ||
    //           setup.receipt_layouts.find((l) => l);
    //         if (trgt) {
    //           vm.template = trgt;
    //         }
    //       }
    //     }
    //   })
    //   .catch((err) => {
    //     error_toast(err);
    //   });
  },
  watch: {},
  updated: function() {},
};
</script>

<style></style>
